import { Component } from '@angular/core';

@Component({
  selector: 'rl-required-field',
  templateUrl: './required-field.component.html',
})
export class RequiredFieldComponent {}
